export type DisplayClipMode =
  | 'text-to-video'
  | 'image-to-video'
  | 'generated-keyframe'
  | 'reference-to-video'
  | 'first-last-frame'
  | 'edit-video'
  | 'video-reference'
  | 'avatar'
  | 'multi-shot'
  | 'uploaded'
  | 'continuation'
  | null

const BASE_MODES = new Set([
  'text-to-video',
  'image-to-video',
  'reference-to-video',
  'first-last-frame',
  'edit-video',
  'video-reference',
  'avatar',
  'multi-shot',
  'uploaded',
])

interface ContinuityClip {
  isJumpCut?: boolean
  referenceFrameUrl?: string
  startKeyframeUrl?: string
  generationMode?: string
}

interface ContinuityPrevClip {
  lastFrameUrl?: string
  endKeyframeUrl?: string
  startKeyframeUrl?: string
  referenceFrameUrl?: string
}

function normalizeAssetUrl(url?: string): string | null {
  if (!url) return null
  try {
    const parsed = new URL(url)
    parsed.search = ''
    parsed.hash = ''
    return parsed.toString()
  } catch {
    return url.split('#')[0].split('?')[0] || null
  }
}

export function hasClipContinuity(current: ContinuityClip, previous?: ContinuityPrevClip | null): boolean {
  if (!previous) return false

  const currentStart = normalizeAssetUrl(current.startKeyframeUrl) || normalizeAssetUrl(current.referenceFrameUrl)
  if (!currentStart) return false

  const previousFrames = [
    previous.lastFrameUrl,
    previous.endKeyframeUrl,
    previous.startKeyframeUrl,
    previous.referenceFrameUrl,
  ]
    .map(normalizeAssetUrl)
    .filter((v): v is string => !!v)

  return previousFrames.includes(currentStart)
}

export function resolveDisplayClipMode(generationMode: string | undefined, hasContinuity: boolean, startKeyframeSource?: string): DisplayClipMode {
  if (hasContinuity && (!generationMode || generationMode === 'image-to-video' || generationMode === 'reference-to-video')) return 'continuation'
  if (!generationMode || !BASE_MODES.has(generationMode)) return null
  if (generationMode === 'image-to-video' && startKeyframeSource === 'generated') return 'generated-keyframe'
  return generationMode as Exclude<DisplayClipMode, 'continuation' | null>
}
